<!-- TODO: classnames will be changed once we got the respective tailwind/mach core classnames -->
<div
  class="min-w-[270px] flex px-[30px] pb-[24px] flex-col items-center gap-5 shadow-md justify-between h-full"
  [ngClass]="content.aspect ? 'gap-0' : ''"
  data-cy="tracker-container"
>
  <idp-header
    [class]="content.aspect === 'collapse' ? 'self-center mb-24 w-[104%]' : ''"
    [content]="content.header"
    (analyticsData)="analyticsData.emit($event)"
    data-cy="tracker-header"
  ></idp-header>
  <div class="mobile:pb-[25%] mobile:pt-[25%] laptop:pb-0 laptop:pt-0">
    <div
      [class]="
        'w-full flex flex-col items-center gap-5 laptop:mt-0' +
        (content.journey.reached ? ' my-auto' : '')
      "
      data-cy="tracker-content"
    >
      <div class="sr-only" data-cy="tracker-aria-label">
        {{ content.ariaLabel }}
      </div>

      <idp-progress-gauge
        [content]="content.earnometer"
        data-cy="tracker-progress-gauge"
      ></idp-progress-gauge>
      <div class="w-full" data-cy="tracker-journey-container">
        <idp-journey
          [content]="content.journey"
          data-cy="tracker-journey"
        ></idp-journey>
      </div>
    </div>

    <div
      *ngIf="!content.journey.reached"
      class="w-full self-start flex flex-col gap-1.5"
      [ngClass]="content.aspect ? 'items-center mt-1.5' + content.aspect : ''"
      data-cy="tracker-footer"
    >
      <div class="mb-12 bg-[#dedfe1]" data-cy="tracker-divider"></div>

      <idp-legends
        [content]="content.legends"
        data-cy="tracker-legends"
      ></idp-legends>

      <div
        *ngIf="!(content.aspect === 'collapse')"
        class="self-start text-[#0b1f66] text-sm font-['Whitney-Light'] font-[325] leading-5"
        data-cy="tracker-timeframe"
      >
        {{ content.timeFrame }}
      </div>
      <div data-cy="tracker-action-container">
        <a
          href="javascript:void(0)"
          *ngIf="!(content.aspect === 'collapse')"
          [attr.aria-label]="content.action.link.label"
          (click)="action.emit(true)"
          id="tracker"
          data-cy="tracker-action-link"
        >
          {{ content.action.link.label }}
        </a>
      </div>
    </div>
  </div>
</div>
